"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionState = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
function ConnectionState() {
    var socketStatus = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).socketStatus;
    return (react_1.default.createElement("div", { className: "flex flex-col items-center justify-center" },
        react_1.default.createElement("div", { className: "font-bold" }, "Socket Status"),
        react_1.default.createElement(react_1.default.Fragment, null, socketStatus ? "Connected" : "Disconnected")));
}
exports.ConnectionState = ConnectionState;
